module.exports = __webpack_public_path__ + "img/zl8.841714b7.jpg";